module.exports = __webpack_public_path__ + "img/info-six-2.250cd9bc.png";